// extracted by mini-css-extract-plugin
module.exports = {"cardDiscovery":"jg-homepage-1C3tB","discoveryCardsHeader":"jg-homepage-1-Les","discoveryCardsContainer":"jg-homepage-2X4Od"};